exports.api  = 'https://id4good.com/api/'

exports.firebaseConfig = {
    apiKey: "AIzaSyCQSsoXLkQ1oypd4PrxMOsbEhS5XgYVFdA",
    projectId: "identity4good",
    databaseURL: "https://identity4good.firebaseio.com",
    messagingSenderId: "1052796377875",
    appId: "1:1052796377875:web:8af3c62c4835c9d8d6d8e6",
    measurementId: "G-Z06RPTE4SL"
}
